export default __webpack_public_path__ + "static/media/oldsouthchurch.8dbceaab.jpeg";